import {Component, OnDestroy, OnInit} from '@angular/core';
import { ThemeService } from '../theme.service';
import { AccountService } from 'src/app/main/services/account.service';
import { FO_ROUTES } from './side-nav-routes.config';
import { Constant } from 'src/app/common/constant';
import { Subject, Subscription } from 'rxjs';
import { AgentService } from 'src/app/main/agent/agent.service';
import { AppQueries } from 'src/app/state';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
import { debounceTime } from 'rxjs/operators';
import { LocalStorageService } from 'ngx-webstorage';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    public Constant = Constant;
    isFolded: boolean;
    isSideNavDark: boolean;
    category: String;
    totalUserDoc: any;
    totalVSD: any;
    totalKycPriority: any;
    totalPendingOrder: any;
    totalRegisterSIP: any;
    totalForeignInvestor: any;
    totalProfile: any;
    totalChangeProfile: any;
    accountNumber: String;
    userType: string;
    isHsbcAgent: boolean = false;
    isContractPartner: boolean = false;
    isFundManagement: boolean = false;
    isSumarryChecking: boolean = false;
    isChangeProfileChecking: boolean = false;
    REFRESH_DATA_INTERVAL = 2; // minutes
    refreshDataLastTime = Date.now();
    userProfile: any;
    subscriptions: Subscription[] = [];
    myInterval: any;
    callApiChangeProfile$ = new Subject();
    url: string = 'link_route';
    selectedIndex : any = null;
    constructor( 
        private router: Router,
        private route: ActivatedRoute,
        private themeService: ThemeService,
        private accountService: AccountService,
        private agentService: AgentService,
        public appQueries: AppQueries,
        private localStorage: LocalStorageService,
        private eventManagerService: EventManagerService
    ) {}

    ngOnInit(): void {
        const accountInfo = this.accountService.getInfo() || {isAdmin: false};
        const routers = JSON.parse(JSON.stringify(FO_ROUTES));
        this.menuItems = routers.filter(menuItem => menuItem);
        this.menuItems.forEach((item) => {
            item.isExpand = false;
            if (item.submenu && item.submenu.length) {
                item.submenu.forEach((subMenu) => {
                    subMenu.isExpand = false;
                })
            }
        })
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);

        this.callApiChangeProfile$.pipe(
            debounceTime(1000),
            ).subscribe((event)=> { return this.countRequestChangeProfile();});
        this.checkKycPriority();
        this.checkTotal();
        this.callApiChangeProfile$.next(true);
        this.checkPendingOrder();
        this.checkRegisterSIP();
        this.countForeignInvestor();
        this.url = this.route.snapshot['_routerState'].url;
        $(document).ready(() => {
            $('.navbar-agent .navbar-toggler').on('click', function() {
              $('.navbar-agent').toggleClass('active');
            });
        });
        this.subscriptions = [
            this.appQueries.userProfile$
            .subscribe((userProfile) => {
                this.userProfile = userProfile;
                this.isHsbcAgent = userProfile.isHsbcAgent;
                this.isContractPartner = userProfile.isContractPartner;
                if (this.userProfile && this.userProfile.id) {
                    this.callApiChangeProfile$.next(true);
                }
            }),
            this.appQueries.foPermission$
            .subscribe((foPermission) => {
                const isSubFo = this.localStorage.retrieve('isSubFo');
                if (!foPermission || !isSubFo) {
                    return;
                }
                const fullPermission = {};
                foPermission.forEach((item) => {
                    if (item.childCodes && item.childCodes.length) {
                        item.childCodes.forEach((item1) => {
                            fullPermission[item1] = true;
                        })
                    }
                    fullPermission[item.parentCode] = true;
                });
                let routers = [];
                FO_ROUTES.forEach((menu) => {
                    if (this.checkPermission(menu, fullPermission, routers)) {
                        routers.push(menu);
                    }
                });
                this.menuItems = routers;
            }),
            this.eventManagerService.subscribe('change-profile', (res) => {
                this.callApiChangeProfile$.next(true);
            }),
            this.eventManagerService.subscribe('profile', (res) => {
                this.checkTotal();
                this.checkKycPriority();
            }),
            this.eventManagerService.subscribe('count-order', (res) => {
                this.checkPendingOrder();
            }),
            this.router.events.subscribe( (event) => {
                if (event instanceof NavigationEnd) {
                   this.url = event.url || '';
                   this.checkUrl(this.url);
                }
            })
        ];
        this.myInterval = setInterval(() => {
            const date = new Date();
            const hour = date.getHours();
            if (hour < 12 || hour > 16) {
                this.refreshData();
            }
        }, 5 * 60 * 1000);
        this.checkUrl(this.url);
    }
    ngOnDestroy() {
        this.eventManagerService.destroys(this.subscriptions);
        clearInterval(this.myInterval);
    }
    checkPermission(menu, fullPermission, routers) {
        if (menu.submenu && menu.submenu.length) {
            let submenus = [];
            menu.submenu.forEach((item) => {
                if (this.checkPermission(item, fullPermission, routers)) {
                    submenus.push(item);
                }
            });
            menu.submenu = submenus || [];
            if (menu.submenu.length) {
                menu.isDisplay = true;
            }
        } else {
            if (!menu.permission || fullPermission[menu.permission]) {
                menu.isDisplay = true;
            }
        }
        return menu.isDisplay;
        // if (menu.isDisplay) {
        //     routers.push(menu);
        // }
    }
    checkUrl(url) {
        const split = (url || '').split('/');
        if (!split[0]) {
            split.shift();
        }
        const routes: any = {};
        split.forEach((route) => routes[route] = true);
        this.menuItems.forEach((menu) => {
            menu.selected = menu.path === '/' + split[0] || menu.path === split[0]; 
        })
    }
    checkTotal() {
        this.agentService.countRegisterTrade() 
        .subscribe((res: any) => {
            const userDocItem = this.menuItems.find(item => item.type === 'USER_DOC') || {};
            const findItem = userDocItem.submenu.find(item => item.permission === 'PROFILE_VSD') || {};
            findItem.count = this.totalVSD = res.data.total;
            this.totalUserDoc = (this.totalVSD || 0) + (this.totalKycPriority || 0) + (this.totalForeignInvestor || 0);
            userDocItem.count = this.totalUserDoc;
        });
    }
    checkKycPriority() {
        this.agentService.countKYCPriority() 
        .subscribe((res: any) => {
            const userDocItem = this.menuItems.find(item => item.type === 'USER_DOC') || {};
            const findItem = userDocItem.submenu.find(item => item.permission === 'PROFILE_KYC') || {};
            findItem.count = this.totalKycPriority = res.data.total;
            this.totalUserDoc = (this.totalVSD || 0) + (this.totalKycPriority || 0) + (this.totalForeignInvestor || 0);
            userDocItem.count = this.totalUserDoc;
        });
    }
    checkRegisterSIP() {
        this.agentService.countRegisterSIP() 
        .subscribe((res: any) => {
            const findItem = this.menuItems.find(item => item.type === 'SIP') || {};
            findItem.count = this.totalRegisterSIP = res.data.total;
        });
    }
    checkPendingOrder() {
        this.agentService.countPendingOrder() 
        .subscribe((res: any) => {
            const findItem = this.menuItems.find(item => item.type === 'TRANSACTION') || {};
            findItem.count = this.totalPendingOrder = res.data.total;
        });
    }
    countRequestChangeProfile() {
        this.isChangeProfileChecking = true;
        return this.agentService.countChangeRequest() 
        .subscribe((res: any) => {
            const findItem = this.menuItems.find(item => item.type === 'CHANGE_INFORMATION') || {};
            findItem.count = this.totalChangeProfile = res.data.total;
            this.isChangeProfileChecking = false;
        });
    }
    countForeignInvestor() {
        return this.agentService.countForeignInvestor() 
        .subscribe((res: any) => {
            const userDocItem = this.menuItems.find(item => item.type === 'USER_DOC') || {};
            const findItem = userDocItem.submenu.find(item => item.type === 'FOREIGN_INVESTOR') || {};
            findItem.count = res.data.total;
            this.totalForeignInvestor = res.data.total;
            this.totalUserDoc = (this.totalVSD || 0) + (this.totalKycPriority || 0) + (this.totalForeignInvestor || 0);
            userDocItem.count = this.totalUserDoc;
        });
    }
    refreshData() {
      this.eventManagerService.broadcast({name: 'profile', content: {}});
      this.eventManagerService.broadcast({name: 'change-profile', content: {}});
      this.countForeignInvestor();
    }
    changeCategory(value) {
        this.category = value;
    }
    signOut() {
        // this.loading.showLoading();
        this.accountService.logout();
    }
}
